import { render } from "./CreateAdmin.vue?vue&type=template&id=b9a9203c"
import script from "./CreateAdmin.vue?vue&type=script&lang=js"
export * from "./CreateAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__